module.exports.DocumentLibraryTabIndexes = {
  YOUR: 0,
  ONCOURSE: 1,
};
